import { IconLoader2 } from '@tabler/icons-react';

const BLoader = ({ title = 'Chargement des données', description = 'Veuillez patientez', isComponent = false }) => {
  return (
    <div className={`flex ${isComponent ? '' : 'min-h-screen'} flex-col items-center justify-center px-4 text-center`}>
      <IconLoader2 className="text-primary-600 animate-spin" size={48} stroke={2} />
      <h1 className="mt-6 text-2xl font-semibold text-slate-700">{title}</h1>
      <p className="max-w-md text-slate-400">{description}</p>
    </div>
  );
};

export default BLoader;
